const Time = '/assets/svg/time.svg';
const Banking = '/assets/svg/banking.svg';
const Ecommerce = '/assets/svg/ecommerce.svg';
const Mirror = '/assets/svg/mirror.svg';
const PaperWork = '/assets/svg/Preliminary.svg';
const Plane = '/assets/svg/plane.svg';
const TimeWatch = '/assets/svg/time-watch.svg';
const Rectangle = '/assets/svg/rectangle.svg';
const Group = '/assets/svg/upload-icon.svg';

export const features = [
    {
        title: "SEND_COMBINED_INVOICE",
        description: "SEND_COMBINED_INVOICE_DESCRIPTION",
        icon: Rectangle,
    },
    {
        title: "TIMEREPORTING",
        description: "TIMEREPORTING_DESCRIPTION",
        icon: Time,
    },
    {
        title: "PRELIMINARYINVOICES",
        description: "PRELIMINARYINVOICES_DESCRIPTION",
        icon: PaperWork,
    },
    {
        title: "PERSONALIZE_LOGO",
        description: "PERSONALIZE_LOGO_DESCRIPTION",
        icon: Group,
    },
    {
        title: "EXPRESS_PAYMENT",
        description: "EXPRESS_PAYMENT_DESCRIPTION",
        icon: Plane,
    },
    {
        title: "SET_ASIDE_HOLIDAY_PAY",
        description: "SET_ASIDE_HOLIDAY_PAY_DESCRIPTION",
        icon: TimeWatch,
    },
    {
        title: "CHANGE_VAT_RATE",
        description: "CHANGE_VAT_RATE_DESCRIPTION",
        icon: Ecommerce,
    },
    {
        title: "SAVING_PENSION_SPP",
        description: "SAVINGPENSIONSPP_DESCRIPTION",
        icon: Banking,
    },
];